import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';
import { DeclaredState, FitnessState, ImmutableState } from '@cf-shared/data-model/user-state';
import { PageRef } from 'providers/page-ref';

export type EditWorkoutsPageParams = {
  mode?: 'intake' | 'edit';  // 'edit' is default
  workoutIndex?: number;
  returnCallback?: string;
  local?: {
    fitnessPlan?: FitnessPlan;
    fitnessState?: FitnessState;
    declaredState?: DeclaredState;
    immutableState?: ImmutableState;
    returnContext?: unknown;
  };
};

/** Result returned when exiting intake mode with saved changes */
export type EditWorkoutsPageResult = {
  fitnessPlan: FitnessPlan;
  fitnessState: FitnessState;
} | undefined;

export const IEditWorkoutsPage: PageRef<EditWorkoutsPageParams, EditWorkoutsPageResult> = {
  pageName: 'EditWorkoutsPage',
} as PageRef<EditWorkoutsPageParams, EditWorkoutsPageResult>;
